import React, { useState, useEffect, useMemo } from 'react'
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import TabsNav from "../common/ProcessNav";
import { Box } from "@mui/material";
import MultipleInput from "../../../components/Card/MultipleInput";
import Table from "./Table"
import Pagination from '../../../components/Pagination/index';
import Loader from '../../../components/Loader/loader';
import SnackBar from '../../../components/Snackbars/CustomizedSnackbars';
import AddProduct from './AddProduct';
import DynamicFilter from "../../../components/Fillter/DyanamicFillter";
import { useDispatch, useSelector } from "react-redux";
import * as pro from "../../../redux/product/actions";
import ConfirmationDialog from '../../../components/DialogBox/Confirmation';
import debounce from "lodash.debounce";
import { formatLocal } from '../../../utility';
import { fetchProductsSitesAndUnitOfOperations } from "../../../redux/visualization/actions";

const ProductList = () => {

    const [page, setPage] = useState(1);
    const [filterOpen, setFilterOpen] = useState(false);
    const [openDailog, setOpenDailog] = useState(false);
    const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
    const userName = localStorage.getItem('userName');
    const [formData, setFormData] = useState({
        product_name: '',
        product_type: '',
        is_multi_approve: false,
        user: userName
    });
    const [snack, setSnack] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [openProduct, setOpenProduct] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const rowsPerPage = 50;
    const [addErrors, setAddErrors] = useState();
    const dispatch = useDispatch();
    const rowData = useSelector((state) => state?.product);
    const [debouncedSearch, setDebouncedSearch] = useState();
    const [search, setSearch] = useState();
    const [filters, setFilters] = useState({
        from_date: "",
        to_date: "",
        product_type: ""
    });

    const filterOptions = [
        { value: "DS", label: "DS" },
        { value: "DP", label: "DP" },
        { value: "API", label: "API" },
    ];

    const filterConfig = [
        {
            key: "product_type",
            label: "Product Type",
            type: "select",
            options: filterOptions,
            optionKey: "value",
            optionLabel: "label",
        },
    ]

    const handleReset = () => {
        setFilters({
            from_date: "",
            to_date: "",
            product_type: ""
        });
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        getProductListCall(value)
    };

    const handleChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    };

    const debouncedSetValue = useMemo(
        () =>
            debounce((val) => {
                setDebouncedSearch(val);
            }, 700),
        []
    );

    const handleSearch = (e) => {
        setSearch(e.target.value);
        debouncedSetValue(e.target.value);
    };

    const validateAddErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!formData.product_name) newErrors.product_name = "Required";
        if (!formData.product_type) newErrors.product_type = "Required";
        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        let newValue;
        if (typeof value === "string") {
            newValue = value?.trim() === "" ? null : value;
        } else {
            newValue = value === "" ? null : value;
        }
        setFormData((prev) => ({ ...prev, [name]: newValue }));
    }

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        if (!validateAddErrors(false)) return;
        if (selectedRow) {
            try {
                const res = await dispatch(pro.UpdateProduct(formData));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenProduct(false)
                getProductListCall(page)
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(pro.AddProduct(formData));
                setSnack({
                    open: true,
                    message: res.data.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenProduct(false)
                getProductListCall(page)

            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const buildFilterPayload = (filters, filterConfig) => {
        const data = {};

        filterConfig.forEach((item) => {
            // 🔹 SELECT / NORMAL FIELD
            if (item.type === "select") {
                if (filters[item.key]) {
                    data[item.key] = filters[item.key];
                }
            }

            // 🔹 DATE RANGE FIELD
            if (item.type === "dateRange") {
                const fromVal = filters[item.fromKey];
                const toVal = filters[item.toKey];

                if (fromVal) {
                    data[item.fromKey] = formatLocal(fromVal);
                }

                if (toVal) {
                    data[item.toKey] = formatLocal(toVal);
                }
            }
        });

        return data;
    };

    const getProductListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        const filterPayload = buildFilterPayload(filters, filterConfig);
        dispatch(pro.getProductList({ ...data, ...filterPayload }))
    }

    useEffect(() => {
        setPage(1)
        getProductListCall(1)
    }, [debouncedSearch])



    const handleDelete = async () => {
        try {
            const res = await dispatch(pro.DeleteProduct({ product_id: selectedRow.product_id, user: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Deleted successfully",
                severity: "success"
            });
            setOpenDailog(false);
            getProductListCall(page)

        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.message || "Something went wrong",
                severity: "error"
            });
        }

    }

    const handleApprove = async (row) => {
        try {
            const res = await dispatch(pro.ApproveProduct({ product_id: selectedRow.product_id, user: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Approved successfully",
                severity: "success"
            });
            setOpenConfirmDailog(false);
            getProductListCall(page)
            dispatch(fetchProductsSitesAndUnitOfOperations());
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.message || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleProductApprove = (row) => {
        setSelectedRow(row)
        setOpenConfirmDailog(true)
    }

    const handleGenerate = () => {
        getProductListCall(1)
    }
    const handleAddProduct = () => {
        setOpenProduct(true)
        setFormData({
            product_name: '',
            product_type: '',
            is_multi_approve: false,
            user: userName
        })
        setSelectedRow('')
    }

    const handleMenuOption = (option, row) => {
        setSelectedRow(row)
        if (option === 'Delete') {
            setOpenDailog(true);
        } else {
            setFormData({
                product_name: row.product_name,
                product_type: row.product_type,
                product_id: row.product_id,
                is_multi_approve: row.is_multi_approve,
                user: userName
            })
            setOpenProduct(true)
        }
    }

    return (
        <> <CAMHeader />
            <CAMDrawer />
            <InvestigatorContainer>  <TabsNav />

                <Box sx={{ borderTop: "1px solid #e0e0e0" }}>
                    <MultipleInput
                        text={'Product List'}
                        buttonText={"Add Product"}
                        popupFilter={true}
                        onButtonClick={handleAddProduct}
                        placeholder={"Search by product name"}
                        // handleChildClick={handleChildClick}
                        // handleClick={handleClick}
                        // handleMenuOptionCallBack={handleMenuOptionCallBack}
                        // filterOptionsGroup1={group1}
                        // filterOptionsGroup2={group2}
                        // selectedFilters={selectedFilters}
                        // handleCheckboxChange={handleCheckboxChange}
                        isButton={true}
                        // isAuditLogs={true}
                        handleSearch={handleSearch}
                        search={search}
                        // viewAuditLogs={viewAuditLogs}
                        // auditText={"Audit Trail"}
                        // viewLogs={viewLogs}
                        // popupFilter={true}
                        handlePopupFilter={() => setFilterOpen(true)}
                    // onBackClick={() => setViewLogs(false)}
                    />
                </Box>
                {snack?.open && (
                    <SnackBar
                        className="popup"
                        handleClose={() => {
                            setSnack({
                                open: false,
                                message: "",
                                severity: "",
                            });
                        }}
                        severity={snack.severity}
                        state={snack?.open}
                        text={snack?.message}
                    />
                )}
                <Box>
                    <AddProduct
                        open={openProduct}
                        formData={formData}
                        onChange={handleOnChange}
                        onClose={() => setOpenProduct(false)}
                        errors={addErrors}
                        handleSubmit={handleAddSubmit}
                        dropdownOption={rowData}
                        product={rowData}
                    // setFieldType={handleSetFieldType}
                    // fieldType={fieldType}
                    // sepcificaitonForm={sepcificaitonForm}
                    // handleAcceptanceValueChange={handleAcceptanceValueChange}
                    // handleDeleteAcceptanceValue={handleDeleteAcceptanceValue}
                    // handleAddAcceptanceValue={handleAddAcceptanceValue}
                    // handleBlockChange={handleBlockChange}
                    // handleAddBlock={handleAddBlock}
                    // handleDeleteBlock={handleDeleteBlock}
                    // parameter={parameter?.data || []}
                    // limitOperation={limitOperation}
                    // handleSaveAsDraft={handleSaveAsDraft}
                    />
                </Box>
                <DynamicFilter
                    open={filterOpen}
                    onClose={() => setFilterOpen(false)}
                    filterValues={filters}
                    onReset={handleReset}
                    onGenerate={handleGenerate}
                    // data={auditLogs || []}
                    onChange={handleChange}
                    isStatusVisible={false}
                    filterConfig={filterConfig}
                />

                <Box width="100%" className="product-table">
                    <ConfirmationDialog
                        open={openDailog}
                        title="Confirm Deletion"
                        message="Do you really want to delete this Unit Operation?"
                        onConfirm={handleDelete}
                        onCancel={() => setOpenDailog(false)}
                    />
                    <ConfirmationDialog
                        open={openConfirmDailog}
                        title="Confirm Approval"
                        message="Are you sure you want to approve this product?"
                        onConfirm={handleApprove}
                        onCancel={() => setOpenConfirmDailog(false)}
                        text='Approve'
                        loading={rowData?.approving?.loading}
                    />
                    <Table data={rowData?.product || []} moreOption={["Update"]} handleMenuOption={handleMenuOption} handleApprove={handleProductApprove} />
                    {rowData?.product?.loading && <Loader />}
                    <Pagination
                        count={rowData?.product?.data?.total / rowsPerPage}
                        page={page}
                        onChange={handlePageChange}
                    />
                </Box>
            </InvestigatorContainer>
        </>
    )
}

export default ProductList